fragment TableFragment on table_Entry {
  typeHandle
  table {
    first
    second
  }
}
